import {
  EXCHANGE_GET_ORDER_ID_SUCCESS,
  EXCHANGE_SET_500_ERROR,
  EXCHANGE_SET_INIT_EXCHANGE_DATA,
  EXCHANGE_SET_NEW_ITEM_ASIN,
  EXCHANGE_SET_PRODUCT_BUNDLE_INFO,
  EXCHANGE_SUBMIT_COMPLETE,
  EXCHANGE_SUBMIT_ERROR,
  EXCHANGE_SUBMIT_INITIATE,
  RECEIVE_POST_EXCHANGE_INFO,
  RECEIVE_PRE_EXCHANGE_INFO
} from 'constants/reduxActions';

const initialState = {
  preExchangeInfo: {},
  postExchangeInfo: {},
  isExchangeSubmitting: false,
  labelInfo: {},
  isExchangeError: false,
  productBundleResponse: {},
  asinSelectedForExchange: null,
  isInitExchangeDataReady: false,
  is500Error: false
};

export default function exchange(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PRE_EXCHANGE_INFO:
      return {
        ...state,
        preExchangeInfo: action.payload
      };
    case EXCHANGE_SUBMIT_INITIATE:
      return {
        ...state,
        isExchangeSubmitting: true,
        isExchangeError: false,
        postExchangeInfo: {},
        contractSummary: {}
      };
    case EXCHANGE_SUBMIT_ERROR:
      return {
        ...state,
        isExchangeSubmitting: false,
        isExchangeError: true
      };
    case EXCHANGE_SUBMIT_COMPLETE:
      return {
        ...state,
        isExchangeSubmitting: false,
        isExchangeError: false
      };
    case RECEIVE_POST_EXCHANGE_INFO:
      return {
        ...state,
        postExchangeInfo: action.payload
      };
    case EXCHANGE_SET_NEW_ITEM_ASIN:
      return {
        ...state,
        asinSelectedForExchange: action.payload
      };
    case EXCHANGE_SET_PRODUCT_BUNDLE_INFO:
      return {
        ...state,
        productBundleResponse: action.payload
      };
    case EXCHANGE_SET_INIT_EXCHANGE_DATA:
      return {
        ...state,
        isInitExchangeDataReady: action.payload
      };
    case EXCHANGE_GET_ORDER_ID_SUCCESS:
      return {
        ...state,
        contractSummary: action.payload
      };
    case EXCHANGE_SET_500_ERROR:
      return {
        ...state,
        is500Error: action.payload
      };
    default:
      return state;
  }
}
